import { Component, EventEmitter, OnInit, Output } from '@angular/core';

import { FormCouponConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { StringInterpolationPipe } from '@frontend/sports/common/core/utils/string-interpolation';
import { NOT_APPLICABLE, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

export interface FormCouponQuickSelector {
    title: string;
    value: number;
}

@Component({
    selector: 'ms-form-coupon-quick-selector',
    templateUrl: './form-coupon-quick-selectors.html',
})
export class FormCouponQuickSelectorsComponent implements OnInit {
    @Output() select = new EventEmitter<number>();
    selectors: FormCouponQuickSelector[] = [];
    active: string | undefined;

    constructor(
        private sitecore: Sitecore,
        private interpolationPipe: StringInterpolationPipe,
        private config: FormCouponConfig,
        private trackingService: TrackingService,
    ) {}

    ngOnInit(): void {
        this.selectors = this.config.quickSelectorButtons.map((button) => {
            if (this.selectors.length === 0) {
                this.active = button.toString();
            }

            return {
                title: this.interpolationPipe.transform(this.sitecore.formCoupon.AddTopPicks, { pickCount: button }),
                value: button,
            };
        });
    }

    addToBetslip(selector: FormCouponQuickSelector): void {
        this.active = selector.value.toString();
        this.select.next(selector.value);
        this.trackClick();
    }

    trackClick(): void {
        this.trackingService.triggerEventWithCleaning(trackingConstants.EVENT_TRACKING, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'sports coupons',
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'FormCoupon',
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'quick select',
            [trackingConstants.COMPONENT_EVENT_DETAILS]: `add ${this.active} bets`,
            [trackingConstants.COMPONENT_POSITION_EVENT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: NOT_APPLICABLE,
        });
    }
}
